// extracted by mini-css-extract-plugin
export default {"loaderCircle":"speak_loaderCircle__WLy+w","loader":"speak_loader__DUjeV","stroke":"speak_stroke__HzJMj"};